// menuConfig.js
export const menuConfig = {
    admin: [
        { title: "Dashboard", path: "/admin-homepage", icon: "fas fa-home" },
        { title: "User Management", icon: "fas fa-users-cog", subItems: [
            { title: "Manage Users", path: "/manage-users" },
            { title: "Student Management", path: "/student-management" },
            { title: "Teacher Management", path: "/teacher-management" },
            { title: "Staff Registration", path: "/staff-registration" },
            { title: "Registration", path: "/registration" },
            { title: "Approve Users", path: "/approve-user" },
            { title: "Assign User", path: "/assign-user" },
            { title: "Assign Children", path: "/assign-children" },
            { title: "Users", path: "/users" },
            { title: "User Profile", path: "/user-profile/:id" }
        ]},
        { title: "Academics", icon: "fas fa-book-open", subItems: [
            { title: "Class Management", path: "/class-management" },
            { title: "Class Manager", path: "/class-manager" },
            { title: "Class Assignment", path: "/class-assignment" },
            { title: "Timetable Management", path: "/timetable-management" },
            { title: "Exam Management", path: "/exam-management" },
            { title: "Upload Results", path: "/upload-results" },
            { title: "Master Result Sheet", path: "/master-report-sheet" },
            { title: "Promote Students", path: "/promote-students" },
            { title: "Academics", path: "/academics" },
            { title: "Create Timetable", path: "/create-timetable" }
        ]},
        { title: "Financials", icon: "fas fa-coins", subItems: [
            { title: "Fee Management", path: "/fee-management" },
            { title: "All Payments", path: "/payments" },
            { title: "Payment", path: "/payment" },
            { title: "Payment Track", path: "/payment-track" },
            { title: "School Fees Track", path: "/school-fees-track" },
            { title: "Refund Management", path: "/admin/refunds" }
        ]},
        { title: "Admission", icon: "fas fa-user-graduate", subItems: [
            { title: "Admission Management", path: "/admission-management" },
            { title: "Student Enrollment", path: "/student-enrollment" },
            { title: "Student Registration", path: "/student-registration" },
            { title: "Admission Letter", path: "/admission-letter/:studentId" }
        ]},
        { title: "Reports", icon: "fas fa-chart-pie", subItems: [
            { title: "School Reports", path: "/school-reports" },
            { title: "Generate Reports", path: "/reports" },
            { title: "View Alerts", path: "/view-alerts" },
            { title: "View Submitted Results", path: "/view-submitted-results" },
            { title: "Print Result Sheet", path: "/print-result-sheet" }
        ]},
        { title: "CBT", icon: "fas fa-laptop", subItems: [
            { title: "CBT Management", path: "/cbt" },
            { title: "CBT Test", path: "/cbt-test" },
            { title: "View CBT Scores", path: "/view-cbt-scores" },
            { title: "View CBT Test Scores", path: "/view-cbt-test-scores" }
        ]},
        { title: "Communication", icon: "fas fa-bullhorn", subItems: [
            { title: "Messaging", path: "/messaging" },
            { title: "Message Detail", path: "/messaging/message/:messageId" },
            { title: "Announcements", path: "/announcements" },
            { title: "Create News", path: "/create-news" },
            { title: "News", path: "/news" },
            { title: "Announcement Upload", path: "/announcement-upload" }
        ]},
        { title: "System", icon: "fas fa-cog", subItems: [
            { title: "System Settings", path: "/system-settings" },
            { title: "Session Management", path: "/session-management" },
            { title: "Stock Management", path: "/stock-management" }
        ]},
        { title: "Profile", icon: "fas fa-user-circle", subItems: [
            { title: "My Profile", path: "/profile" },
            { title: "Change Password", path: "/change-password" },
            { title: "Notifications", path: "/notifications" },
            { title: "Upload Image", path: "/upload-image" }
        ]}
    ],
    principal: [
        { title: "Dashboard", path: "/principal-homepage", icon: "fas fa-home" },
        { title: "Oversight", icon: "fas fa-eye", subItems: [
            { title: "Teacher Oversight", path: "/teacher-oversight" },
            { title: "Academic Reports", path: "/school-reports" },
            { title: "View Alerts", path: "/view-alerts" }
        ]},
        { title: "Academic Management", icon: "fas fa-school", subItems: [
            { title: "Master Result Sheet", path: "/master-report-sheet" },
            { title: "View Submitted Results", path: "/view-submitted-results" },
            { title: "Promote Students", path: "/promote-students" },
            { title: "Academics", path: "/academics" }
        ]},
        { title: "Communication", icon: "fas fa-bullhorn", subItems: [
            { title: "Approve Users", path: "/approve-user" },
            { title: "Announcement Upload", path: "/announcement-upload" },
            { title: "Create News", path: "/create-news" }
        ]},
        { title: "CBT", icon: "fas fa-laptop", subItems: [
            { title: "CBT Management", path: "/cbt" },
            { title: "CBT Test", path: "/cbt-test" },
            { title: "View CBT Scores", path: "/view-cbt-scores" },
            { title: "View CBT Test Scores", path: "/view-cbt-test-scores" }
        ]},
        { title: "Profile", icon: "fas fa-user-circle", subItems: [
            { title: "My Profile", path: "/profile" },
            { title: "Change Password", path: "/change-password" },
            { title: "Notifications", path: "/notifications" }
        ]}
    ],
    cashier: [
        { title: "Dashboard", path: "/cashier-homepage", icon: "fas fa-home" },
        { title: "Payments", icon: "fas fa-credit-card", subItems: [
            { title: "Fee Management", path: "/fee-management" },
            { title: "Log Payment", path: "/payment" },
            { title: "Payment Records", path: "/payments" },
            { title: "Fees & Payments", path: "/fees" }
        ]},
        { title: "Inventory", icon: "fas fa-boxes", subItems: [
            { title: "Stock Management", path: "/stock-management" }
        ]},
        { title: "Profile", icon: "fas fa-user-circle", subItems: [
            { title: "My Profile", path: "/profile" },
            { title: "Change Password", path: "/change-password" },
            { title: "Notifications", path: "/notifications" }
        ]}
    ],
    teacher: [
        { title: "Dashboard", path: "/teacher-homepage", icon: "fas fa-home" },
        { title: "My Classes", icon: "fas fa-chalkboard-teacher", subItems: [
            { title: "My Students", path: "/my-students" },
            { title: "My Classes", path: "/my-classes" },
            { title: "Gradebook", path: "/gradebook" },
            { title: "Search Students", path: "/search-students" }
        ]},
        { title: "Assessments", icon: "fas fa-clipboard-list", subItems: [
            { title: "Score Sheet", path: "/score-sheet" },
            { title: "Update CA", path: "/update-ca" },
            { title: "Input Results", path: "/class/:className/results" },
            { title: "Upload Results", path: "/upload-results" }
        ]},
        { title: "Assignments", icon: "fas fa-tasks", subItems: [
            { title: "Assignment Management", path: "/assignment-management" },
            { title: "Create Assignment", path: "/create-assignment" },
            { title: "Manage Assignments", path: "/class/:className/assignments" },
            { title: "View Submissions", path: "/class/:className/assignment/:assignmentId/submissions" }
        ]},
        { title: "Attendance", icon: "fas fa-calendar-check", subItems: [
            { title: "Attendance Tracking", path: "/attendance-tracking" },
            { title: "Take Attendance", path: "/class/:className/attendance" }
        ]},
        { title: "CBT", icon: "fas fa-laptop", subItems: [
            { title: "CBT Test", path: "/cbt-test/teacher" },
            { title: "View CBT Scores", path: "/view-cbt-scores" },
            { title: "View CBT Test Scores", path: "/view-cbt-test-scores" }
        ]},
        { title: "Profile", icon: "fas fa-user-circle", subItems: [
            { title: "My Profile", path: "/profile" },
            { title: "Change Password", path: "/change-password" },
            { title: "Notifications", path: "/notifications" }
        ]}
    ],
    student: [
        { title: "Dashboard", path: "/student-homepage", icon: "fas fa-home" },
        { title: "Academics", icon: "fas fa-book", subItems: [
            { title: "My Courses", path: "/my-courses" },
            { title: "Timetable", path: "/timetable" }
        ]},
        { title: "Assignments", icon: "fas fa-tasks", subItems: [
            { title: "Assignments", path: "/assignments" },
            { title: "Student Assignments", path: "/student-assignments/:className" },
            { title: "Assignment Details", path: "/assignment-details/:id" },
            { title: "Submission Form", path: "/submission-form/:id" }
        ]},
        { title: "Exams & Results", icon: "fas fa-poll", subItems: [
            { title: "Results", path: "/results" },
            { title: "Grades", path: "/grades" },
            { title: "Exam List", path: "/exam-list" },
            { title: "Take Exam", path: "/exam/:examId" }
        ]},
        { title: "CBT", icon: "fas fa-laptop", subItems: [
            { title: "Student CBT", path: "/student-cbt" },
            { title: "Student CBT Test", path: "/student-cbt-test" },
            { title: "CBT Exam", path: "/cbt/exam/:examId" }
        ]},
        { title: "Payments", icon: "fas fa-money-bill-wave", subItems: [
            { title: "Pay Fees", path: "/student-payment" },
            { title: "Student Fees", path: "/student-fees" },
            { title: "Payment Track", path: "/payment-track" },
            { title: "Payment Callback", path: "/payment-callback" },
            { title: "My Refunds", path: "/my-refunds" }
        ]},
        { title: "Profile", icon: "fas fa-user-circle", subItems: [
            { title: "My Profile", path: "/profile" },
            { title: "Change Password", path: "/change-password" },
            { title: "Notifications", path: "/notifications" }
        ]}
    ],
    parent: [
        { title: "Dashboard", path: "/parent-homepage", icon: "fas fa-home" },
        { title: "Children", icon: "fas fa-child", subItems: [
            { title: "Children's Results", path: "/my-childrens-result" },
            { title: "Fees & Payments", path: "/fees-and-payments" }
        ]},
        { title: "Communication", icon: "fas fa-envelope", subItems: [
            { title: "Messages", path: "/messaging" },
            { title: "Message Detail", path: "/messaging/message/:messageId" },
            { title: "Notifications", path: "/notifications" }
        ]},
        { title: "Profile", icon: "fas fa-user-circle", subItems: [
            { title: "My Profile", path: "/profile" },
            { title: "Change Password", path: "/change-password" }
        ]}
    ],
    'form-master': [
        { title: "Dashboard", path: "/form-master-homepage", icon: "fas fa-home" },
        { title: "Class Management", icon: "fas fa-users", subItems: [
            { title: "Manage Class", path: "/class-manager" },
            { title: "My Students", path: "/my-students" },
            { title: "Search Students", path: "/search-students" }
        ]},
        { title: "Attendance", icon: "fas fa-calendar-check", subItems: [
            { title: "Student Attendance", path: "/attendance" },
            { title: "Take Attendance", path: "/class/:className/attendance" },
            { title: "Attendance Tracking", path: "/attendance-tracking" }
        ]},
        { title: "Timetable", icon: "fas fa-calendar-alt", subItems: [
            { title: "Create Timetable", path: "/create-timetable" },
            { title: "Timetable", path: "/timetable" }
        ]},
        { title: "Assessments", icon: "fas fa-clipboard-list", subItems: [
            { title: "Score Sheet", path: "/score-sheet" },
            { title: "Assess Traits", path: "/traits-assessment" },
            { title: "Update CA", path: "/update-ca" },
            { title: "Input Results", path: "/class/:className/results" }
        ]},
        { title: "Reports", icon: "fas fa-chart-line", subItems: [
            { title: "Master Result Sheet", path: "/master-report-sheet" },
            { title: "View Alerts", path: "/view-alerts" },
            { title: "View Submissions", path: "/class/:className/assignment/:assignmentId/submissions" },
            { title: "View Submitted Results", path: "/view-submitted-results" }
        ]},
        { title: "CBT", icon: "fas fa-laptop", subItems: [
            { title: "CBT Test", path: "/cbt-test/teacher" },
            { title: "View CBT Scores", path: "/view-cbt-scores" },
            { title: "View CBT Test Scores", path: "/view-cbt-test-scores" }
        ]},
        { title: "Communication", icon: "fas fa-bullhorn", subItems: [
            { title: "Create News", path: "/create-news" },
            { title: "Announcements", path: "/announcements" },
            { title: "Messaging", path: "/messaging" }
        ]},
        { title: "Profile", icon: "fas fa-user-circle", subItems: [
            { title: "My Profile", path: "/profile" },
            { title: "Change Password", path: "/change-password" },
            { title: "Notifications", path: "/notifications" }
        ]}
    ],
    default: [
        { title: "Dashboard", path: "/profile/", icon: "fas fa-home" },
        { title: "Buy Data", path: "/data_Create/", icon: "fas fa-signal" },
        { title: "Buy Airtime", path: "/AirtimeTopupCreate/", icon: "fas fa-phone-square" },
        {
            title: "Utilities Payment",
            icon: "fas fa-lightbulb",
            subItems: [
                { title: "Bill Payment", path: "/billpayment/" },
                { title: "Cable Subscription", path: "/Cablesub/" },
            ],
        },
        {
            title: "Fund Wallet",
            icon: "fas fa-credit-card",
            subItems: [
                { title: "Fund with Paystack (ATM)", path: "/payonline/" },
                { title: "Fund with payment gateway (ATM)", path: "/pay_with_monnify/" },
                { title: "Automated Bank Transfer (N50 charge)", path: "/autobank/" },
                { title: "Fund with coupon", path: "/Coupon_Payment/" },
            ],
        },
        { title: "Result Checker", path: "/Result-Checker-Pin-order/", icon: "fas fa-credit-card" },
        {
            title: "Transactions",
            icon: "fas fa-money-bill",
            subItems: [
                { title: "Transactions", path: "/history/" },
                { title: "Data Transactions", path: "/Data_History_new/" },
                { title: "Airtime Transactions", path: "/Airtime_History_new/" },
            ],
        },
        { title: "Wallet Summary", path: "/Wallet_Summary/", icon: "fas fa-money-bill" },
        { title: "My Referrals", path: "/referal/", icon: "fas fa-money-bill" },
        { title: "Pricing", path: "/pricing/", icon: "fas fa-money-bill" },
        { title: "Account", path: "/user-detail/", icon: "fas fa-user" },
        { title: "Change Pin", path: "/User/account_pin/", icon: "fas fa-cog" },
        { title: "Settings", path: "/EditProfile/", icon: "fas fa-cog" },
    ]
};